// hooks/useStudentGroups.js
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackError } from '../Reducers/snackErrors';
import { adminService } from '../Services/adminService';
import { setSuccessSnack } from '../Reducers/snackSuccess';
import { announcementService } from '../Services/announcementService';
import { handleApiError } from '../Utils/ApiErrorHandler';

export const useGetAnnouncements = () => {
    const dispatch = useDispatch();

    const [announcements, setAnnouncements] = useState([]);
    const [announcementAck, setAnnouncementAck] = useState([]);

    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [creating, setCreating] = useState(false);

  const fetchAnnouncements = async (location_ids, program_ids) => {
    setLoading(true);
    try {
      const data = await announcementService.getAnnouncments(location_ids, program_ids);
      setAnnouncements(data);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, "get announcments")
      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchAnnouncementAck = async (id) => {
    setLoading(true);
    try {
      const data = await announcementService.getAnnouncmentAck(id)
      setAnnouncementAck(data);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, "get announcments ack")
      return null;
    } finally {
      setLoading(false);
    }
  };

  const ackAnnouncments = async (id) => {
    setLoading(true);
    try {
      const data = await announcementService.ackAnnouncments(id);
      if (data.status === 'OK' || data.status === 'acknowledged') {
        dispatch(setSuccessSnack({
            title: 'Success',
            body: 'Acknowledged '
          }));
          return true
      }
      return false
    } catch (error) {
      handleApiError(error, dispatch, "ackAnnouncments announcments")
      return false;
    } finally {
      setLoading(false);
    }
  };

  const createAnnouncement = async (values) => {
    try {
      setCreating(true);
      const data = await announcementService.createAnnouncement(values);
      
      if (data.status === 'OK') {
        dispatch(setSuccessSnack({
          title: 'Success', 
          body: `Announcement created successfully with id ${data.id}`
        }));
        return true;
      }
      return false;
    } catch (error) {
      handleApiError(error, dispatch, 'create announcement');
      return false;
    } finally {
      setCreating(false);
    }
  };
  
  const updateAnnouncement = async (values) => {
    try {
      setUpdating(true);
      const data = await announcementService.updateAnnouncement(values);
      if (data.status === 'Updated') {
        dispatch(setSuccessSnack({
          title: 'Success', 
          body: 'Announcement updated successfully'
        }));
        return true;
      }
      return false;
    } catch (error) {
      handleApiError(error, dispatch, 'update announcement');
      return false;
    } finally {
      setUpdating(false);
    }
  };
  const deleteAnnouncement = async (id) => {
    try {
        setDeleting(true);
        const data = await announcementService.deleteAnnouncement(id);
        if (data.status === 'Removed') {
          dispatch(setSuccessSnack({
            title: 'Success', 
            body: 'Removed announcement updated successfully'
          }));
          return true;
        }
        return false;
      } catch (error) {
        handleApiError(error, dispatch, 'delete announcement');
        return false;
      } finally {
        setDeleting(false);
      }
  }

  return { 
    announcements, 
    announcementAck,
    loading,
    deleting,
    updating,
    creating,
    fetchAnnouncements,
    ackAnnouncments,
    createAnnouncement,
    updateAnnouncement,
    deleteAnnouncement,
    fetchAnnouncementAck
  };
};